export default __webpack_public_path__ + "static/media/9da0bce904b1ac03a0ddcc74ad2e7f211636547371638.44785e28.webp";